// src/utils/dateUtils.js
import moment from "jalali-moment";
import jalaali from "jalaali-js";

export const convertToJalali = (date) => {
  if (date) {
    const formatted = moment(date, "jYYYY-jMM-jDD HH:mm:ss").format(
      "jYYYY-jMM-jDD - HH:mm"
    );
    return formatted;
  }

  return date;
};

export const convertUnixToJalali = (unixTimestamp) => {
  if (!unixTimestamp) {
    return unixTimestamp;
  }
  const jsDate = new Date(unixTimestamp);
  const jDate = jalaali.toJalaali(jsDate);
  return `${jDate.jy}/${jDate.jm}/${jDate.jd}`;
};

export const convertUnixToIso = (unixTimestamp) => {
  const date = new Date(unixTimestamp);

  const isoFormatDate = date.toISOString();
  return isoFormatDate;
};

export function convertToIranianDate(dateString) {
  if (!dateString) return dateString;

  const date = new Date(dateString);

  return moment(date).format("jYYYY-jMM-jDD");
}
